<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition" :nudge-width="300">
    <template v-slot:activator="{ on }">
      <v-btn
        color="indigo"
        dark
        small
        v-on="on"
      >
        <v-icon left>{{ filterIcon }}</v-icon>
        <span>{{ header }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-card-subtitle>{{ header }}</v-card-subtitle>
        <v-spacer></v-spacer>
        <v-btn icon @click="clearData">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ filterRemoveIcon }}</v-icon>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.map.tableFilter.clear') }}</span>
          </v-tooltip>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <span class="caption">{{ $vuetify.lang.t('$vuetify.map.managerMap.filterHeaders.lowerBound') }}</span>
        <v-row no-gutters>
          <v-col>
            <duration-filter ref="startDurationFilter" type="start" @value-changed="sendValue"></duration-filter>
          </v-col>
        </v-row>
        <span class="caption">{{ $vuetify.lang.t('$vuetify.map.managerMap.filterHeaders.upperBound') }}</span>
        <v-row no-gutters>
          <v-col>
            <duration-filter ref="finishDurationFilter" type="finish" @value-changed="sendValue"></duration-filter>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiFilter, mdiFilterRemove } from '@mdi/js'
import DurationFilter from './utils/durationFilter'

export default {
  name: 'durationGroupFilter',
  components: { DurationFilter },
  props: {
    column: String,
    header: String
  },
  data: () => ({
    menu: false,

    filterIcon: mdiFilter,
    filterRemoveIcon: mdiFilterRemove
  }),
  methods: {
    clearData (emit = true) {
      const fields = ['start', 'finish']
      for (const field of fields) {
        const filter = this.$refs[`${field}DurationFilter`]
        if (filter) {
          filter.clearState()
        }
      }

      if (emit) {
        this.$emit('duration-cleared', { 'column': this.column })
      }
    },
    sendValue (value) {
      this.$emit('duration-changed', { ...value, 'column': this.column })
    }
  }
}
</script>

<style scoped>

</style>
